import { twMerge } from '@/lib/classname/twMerge'
import type { ReactNode } from 'react'
import { BaseSkeleton } from './BaseSkeleton'

export const SKELETON_TEXT_SIZE = {
  sm: 'text-sm',
  md: 'text-md',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
  '3xl': 'text-3xl',
  '4xl': 'text-4xl',
  '5xl': 'text-5xl',
} as const

export const SKELETON_TEXT_LEADING = {
  compact: 'leading-compact',
  normal: 'leading-normal',
  light: 'leading-light',
  lighter: 'leading-lighter',
} as const

export type SkeletonTextProps = {
  className?: string
  size: keyof typeof SKELETON_TEXT_SIZE
  leading: keyof typeof SKELETON_TEXT_LEADING
  children?: ReactNode
}

export function TextSkeleton({ className, size, leading, children }: SkeletonTextProps) {
  return (
    <BaseSkeleton
      className={twMerge(
        'h-auto min-w-4 max-w-full',
        SKELETON_TEXT_SIZE[size],
        SKELETON_TEXT_LEADING[leading],
        className,
      )}
    >
      {children ? <span className="block opacity-0">{children}</span> : null}
    </BaseSkeleton>
  )
}
